import {
  addNavMenuItem,
  registerBulkAction,
  registerCustomDetailComponent,
} from '@vendure/admin-ui/core'
import { deleteCompanies, deleteEmployments } from './bulk-actions'
import { CustomerEmploymentListComponent } from './components/customer-employment-list/customer-employment-list.component'

export default [
  addNavMenuItem(
    {
      id: 'companies',
      label: 'org-hierarchy.companies',
      routerLink: ['/extensions/companies'],
      icon: 'organization',
      requiresPermission: 'ReadCompany',
    },
    'customers',
  ),
  registerBulkAction(deleteEmployments),
  registerBulkAction(deleteCompanies),
  registerCustomDetailComponent({
    locationId: 'customer-detail',
    component: CustomerEmploymentListComponent,
  }),
]
